/**
 * The narrowest window, in CSS px, at which the dashboard keeps its sidebar. Below it the app header
 * and its nav drawer take over.
 *
 * One number for the three places that have to agree on it: the layout draws the sidebar, the
 * header hides itself, and the app shell starts the footer after the sidebar. If any of them used a
 * different breakpoint, some window width would show both menus, or neither.
 *
 * Tablet width, not DESIGN §5's "above 1200px" (AT-2637). At 1201 a laptop zoomed to 110% or 125%
 * lost its menu to a phone's hamburger, which is the moment someone zoomed in to read is least able
 * to find it. Every signed-in page was checked down to 960 with the sidebar standing: none overflows.
 *
 * A plain number rather than a design-system `BREAKPOINTS` entry, because the unit tests mock the
 * design system, `BREAKPOINTS` included, with different values.
 */
export const DASHBOARD_SIDEBAR_MIN_WIDTH = 960;

export const DASHBOARD_SIDEBAR_QUERY = `(min-width: ${DASHBOARD_SIDEBAR_MIN_WIDTH}px)`;
